import { KeywordStatShowItem } from '../api/RestApiManager';
import { PhrasesSelectorListItem } from '../typings/phrases';

export const mapPhraseToPhrasesSelectorListItem = ({
    phrase,
    shows
}: KeywordStatShowItem): PhrasesSelectorListItem => ({
    text: phrase,
    shows,
    selected: false
});

export const mapStringToPhrasesSelectorListItem = (
    text: string
): PhrasesSelectorListItem => ({
    text,
    shows: 0,
    selected: false
});

export const splitOneSelectorListItemToSeveral = (
    el: PhrasesSelectorListItem
): Array<PhrasesSelectorListItem> =>
    el.text.split(' ').map(mapStringToPhrasesSelectorListItem);
